module.exports = __webpack_public_path__ + "assets/724a965fe94c6859b40ecc1320bccc6e.png";